import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ScholarshipDetails } from '../../classes/scholarship-details';
import { AppService } from '../../services/app.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { UserInfo, UserService } from '../../services/user.service';
import { ErrorService } from '../../services/error.service';
import { ScreenSizeService } from '@polk_county_public_schools/ngx-pcps-dialogs/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-preview',
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.scss'],
    imports: [
        MatFormFieldModule,
        MatCardModule,
        MatDividerModule,
        MatButtonModule,
        RouterModule,
        MatInputModule,
        FormsModule,
        CommonModule,
        MatRadioModule,
        MatTooltipModule
    ]
})
export class PreviewComponent implements OnInit {
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly appSvc = inject(AppService);
    protected readonly route = inject(ActivatedRoute);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly userSvc = inject(UserService);
    protected readonly errorSvc = inject(ErrorService);
    protected readonly screenSizeSvc = inject(ScreenSizeService);
    user: UserInfo;
    masterID: number;
    details: ScholarshipDetails;
    smallScreen: boolean;
    radio: boolean;

    ngOnInit() {
        this.user = this.userSvc.User;
        this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
            this.masterID = +params['id'];
            this.getScholarshipDetails();
        });
        this.screenSizeSvc.ScreenSizeSub
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((size) => {
                if (size == null) return;
                this.smallScreen = size.IsXs;
            });
    }

    getScholarshipDetails() {
        this.appSvc.GetScholarshipDetails(this.masterID).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                this.details = res;
            }, error: error => {
                this.errorSvc.HandleServiceError(error);
            }
        });
    }

    resetRadio(value: boolean) {
        // If the clicked value is already selected, clear it. Otherwise, set it.
        //this.radio is previous value before click
        if (this.radio === value) {
            this.radio = null;
        } else {
            this.radio = value;
        }
    }
}
